export default __webpack_public_path__ + "static/media/BgGroup38511.5f870aa9.png";